import ApiService from "../../api.service";
import {SET_ERROR} from "../auth.module";

export const GET_DOMAIN_REVIEW_LIST = "level-approval-request/progress-personal";
export const GET_PROGRESS_PERSONAL_LIST = "level-approval-request/progress-personal";
export const GET_DETAIL_MINUS_POINT = "level-approval-request/detail-minus-point";

const state = {
};

const getters = {
};

const actions = {
    [GET_DOMAIN_REVIEW_LIST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(GET_DOMAIN_REVIEW_LIST, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                });
        });
    },

    [GET_PROGRESS_PERSONAL_LIST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${GET_PROGRESS_PERSONAL_LIST}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

    [GET_DETAIL_MINUS_POINT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_DETAIL_MINUS_POINT, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                })
        });
    },
};

const mutations = {
};

export default {
    state,
    actions,
    mutations,
    getters,
};
